/** @jsx jsx */
import { jsx } from '@emotion/react';

import { seoMetaTitleExceptions } from 'bundles/browse-common/utils/seo';
import CourseraMetatags from 'bundles/seo/components/CourseraMetatags';

type DomainLike = {
  name: string;
  description: string;
};

type Props = {
  domain: DomainLike;
  subdomain?: DomainLike;
};

const DomainMetatags = (props: Props) => {
  const { domain, subdomain } = props;

  const seoDomainName = `${domain.name} Online Courses`;
  let seoSubDomainName = '';

  if (subdomain) {
    seoSubDomainName = `${subdomain.name} Online Courses`;
  }

  let metaTitle = subdomain ? seoSubDomainName : seoDomainName;
  if (seoMetaTitleExceptions.includes(metaTitle)) {
    metaTitle += ' Certificates';
  }

  const metaDescription = subdomain ? subdomain.description : domain.description;
  const metaDescriptionName = subdomain ? subdomain.name : domain.name;

  return (
    <CourseraMetatags
      metaNameAndProperties={{
        title: metaTitle,
        description: `Choose from hundreds of free ${metaDescriptionName} courses or pay to earn a Course or Specialization Certificate. ${metaDescription}`,
      }}
    />
  );
};

export default DomainMetatags;
